/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["usiku","mchana","alfajiri","asubuhi","mchana","jioni","usiku"],["saa sita za usiku","adhuhuri","alfajiri","asubuhi","mchana","jioni","usiku"],["saa sita za usiku","saa sita za mchana","alfajiri","asubuhi","mchana","jioni","usiku"]],[["saa sita za usiku","saa sita za mchana","alfajiri","asubuhi","mchana","jioni","usiku"],["saa sita za usiku","adhuhuri","alfajiri","asubuhi","alasiri","jioni","usiku"],["saa sita za usiku","saa sita za mchana","alfajiri","asubuhi","mchana","jioni","usiku"]],["00:00","12:00",["04:00","07:00"],["07:00","12:00"],["12:00","16:00"],["16:00","19:00"],["19:00","04:00"]]];
